import React from 'react';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import '../styles/AboutPage.css';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BlockchainNetworkAnimation from '../components/BlockchainNetworkAnimation';

function AboutPage() {
  return (
    <div className="about-page">
      <BlockchainNetworkAnimation>
            <Stack direction='column' spacing={2} justifyContent='center'>
              <Typography variant="h3" component="h1" sx={{ mb: 1, fontWeight: 'bold', color: 'white' }}>
                About Layer X
              </Typography>
              <Typography variant="h4" component="h2" sx={{ mb: 3, color: 'white' }}>
                Securing Next-Generation Blockchains
              </Typography>
          </Stack>
      </BlockchainNetworkAnimation>

      <section className="about-mission">
        <div className="container">
          <h2>Our Mission</h2>
          <p>We believe high-throughput blockchains are challenging legacy networks and are poised to onboard the next wave of crypto adoption. Layer X supports these advanced blockchain protocols by providing innovative and secure staking infrastructure.</p>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2>Our Team</h2>
          <p className="team-intro">Meet the team behind Layer X</p>
          
          <Grid container spacing={4} className="team-grid">
            <Grid size={{ xs: 12, md: 3 }}>
              <Card className="team-card">
                <div className="member-photo">
                  <img src='/bio-images/ceo.jpg' alt="Mat Cybula" />
                </div>
                <CardContent>
                  <h3>Mat Cybula</h3>
                  <p className="member-title">CEO</p>
                  <p className="member-bio">Mat is an entrepreneur with over a decade of experience in the crypto industry. He holds an MSc from the London School of Economics and was formerly the CEO and co-founder of Cryptiv Inc., a custodial wallet provider acquired by Coinsquare in 2019. Mat has a deep understanding of blockchain technologies, crypto markets, and the systems that drive them, making him adept at building innovative solutions in the evolving world of digital finance.</p>
                </CardContent>
              </Card>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <Card className="team-card">
                <div className="member-photo">
                  <img src='/bio-images/coo.jpg' alt="Filip Cybula" />
                </div>
                <CardContent>
                  <h3>Filip Cybula</h3>
                  <p className="member-title">COO</p>
                  <p className="member-bio">Filip has been an entrepreneur in the crypto industry since 2015. As COO and co-founder of Cryptiv, a custodial wallet provider, he led the company's strategy and growth. Filip specializes in evaluating the fundamental drivers of blockchain networks and understanding their crypto-economic structures. He holds an MSc from the University of Oxford, where his research explored the disruptive impact of the Internet on centralized organizations.</p>
                </CardContent>
              </Card>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <Card className="team-card">
                <div className="member-photo">
                  <img src='/bio-images/cto.jpg' alt="Geoff Byers" />
                </div>
                <CardContent>
                  <h3>Geoff Byers</h3>
                  <p className="member-title">CTO</p>
                  <p className="member-bio">Geoff is a seasoned crypto developer with over a decade of experience in building secure systems. As CTO and co-founder of Cryptiv, he developed institutional-grade crypto custody solutions, leveraging his deep expertise in reverse engineering and cybersecurity. Previously, Geoff served as CTO of Tetra Trust, Canada’s first qualified crypto custodian. Active in blockchain since 2014, Geoff is committed to advancing secure blockchain infrastructure.</p>
                </CardContent>
              </Card>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <Card className="team-card">
                <div className="member-photo">
                  <img src='/bio-images/cfo.jpg' alt="Martin Bui" />
                </div>
                <CardContent>
                  <h3>Martin Bui</h3>
                  <p className="member-title">CFO</p>
                  <p className="member-bio">Martin graduated from York University with a degree in Accounting & Finance. He has worked across private and public companies in industries like manufacturing, pharmaceuticals, and crypto. Most recently, Martin led financial reporting and corporate finance at Hut 8 Mining. With experience in technical accounting, corporate governance, capital markets, and public company compliance, Martin is a seasoned finance professional.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;